import { __assign, __rest } from "tslib";
import React, { useCallback } from 'react';
import { fireNonCancelableEvent } from '../internal/events';
import Box from '../box';
import Button from '../button';
import InternalFormField from '../form-field/internal';
import ColumnLayout from '../column-layout';
import InternalGrid from '../grid/internal';
import styles from './styles.css.js';
var Divider = function () { return React.createElement(Box, { className: styles.divider, padding: { top: 'l' } }); };
var Attribute = function (_a) {
    var control = _a.control, props = __rest(_a, ["control"]);
    return (React.createElement(InternalFormField, __assign({}, props, { className: styles.field, stretch: true }), control));
};
var GRID_DEFINITION = [{ colspan: { "default": 12, xs: 9 } }, { colspan: { "default": 12, xs: 3 } }];
var Row = React.memo(function (_a) {
    var breakpoint = _a.breakpoint, item = _a.item, definition = _a.definition, index = _a.index, removable = _a.removable, removeButtonText = _a.removeButtonText, onRemoveButtonClick = _a.onRemoveButtonClick;
    var isNarrowViewport = breakpoint === 'default' || breakpoint === 'xxs';
    var isWideViewport = !isNarrowViewport;
    var handleRemoveClick = useCallback(function () {
        fireNonCancelableEvent(onRemoveButtonClick, { itemIndex: index });
    }, [onRemoveButtonClick, index]);
    var render = function (item, itemIndex, slot) {
        return typeof slot === 'function' ? slot(item, itemIndex) : slot;
    };
    return (React.createElement(Box, { className: styles.row, margin: { bottom: 's' } },
        React.createElement(InternalGrid, { breakpoint: breakpoint, gridDefinition: GRID_DEFINITION },
            React.createElement(ColumnLayout, { className: styles['row-control'], columns: definition.length }, definition.map(function (_a, defIndex) {
                var info = _a.info, label = _a.label, constraintText = _a.constraintText, errorText = _a.errorText, control = _a.control;
                return (React.createElement(Attribute, { key: defIndex, label: label, info: info, constraintText: constraintText && render(item, index, constraintText), errorText: errorText && render(item, index, errorText), control: control && render(item, index, control), hideLabel: isWideViewport && index > 0 }));
            })),
            removable && (React.createElement(ButtonContainer, { disablePaddings: isNarrowViewport || index > 0 },
                React.createElement(Button, { className: styles['remove-button'], onClick: handleRemoveClick }, removeButtonText)))),
        isNarrowViewport && React.createElement(Divider, null)));
});
var ButtonContainer = function (_a) {
    var disablePaddings = _a.disablePaddings, children = _a.children;
    return disablePaddings ? React.createElement(React.Fragment, null, children) : React.createElement("div", { className: styles['button-container'] }, children);
};
export var Rows = function (_a) {
    var items = _a.items, definition = _a.definition, breakpoint = _a.breakpoint, isItemRemovable = _a.isItemRemovable, removeButtonText = _a.removeButtonText, onRemoveButtonClick = _a.onRemoveButtonClick;
    return (React.createElement(Box, { margin: { bottom: 'l' } }, items.map(function (item, index) { return (React.createElement(Row, { key: index, breakpoint: breakpoint, index: index, item: item, definition: definition, removable: isItemRemovable(item), removeButtonText: removeButtonText, onRemoveButtonClick: onRemoveButtonClick })); })));
};
export var AdditionalInfo = function (_a) {
    var children = _a.children;
    return (React.createElement(Box, { className: styles['additional-info'], margin: { top: 'xxs' } }, children));
};
export var Empty = function (_a) {
    var children = _a.children;
    return (React.createElement(Box, { className: styles.empty, margin: { bottom: 'l' } }, children));
};
